export function updateTitle(newTitle: string) {
    const titleElement = document.getElementById("dynamic-title");
    if (titleElement) {
        titleElement.textContent = newTitle || "AEPD | Agencia Española de Protección de Datos";
    }
}
